"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "isResolvedShorthand", {
    enumerable: true,
    get: function() {
        return isResolvedShorthand;
    }
});
const _react = require("react");
function isResolvedShorthand(shorthand) {
    return shorthand !== null && typeof shorthand === 'object' && !Array.isArray(shorthand) && !(0, _react.isValidElement)(shorthand);
}
